let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8i1vn")).then(() => parcelRequire('3T5bx'));